export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11467.63e2725a.jpg";